import { EnvironmentService } from './../shared/services/environment.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { AlertService } from '../shared/components/app-alert';
import { ConfirmModalComponent } from '../shared/components/confirm-modal/confirm-modal.component';
import { AADAuthenticationService } from '../shared/services/aadauthentication.service';
import { AccountInfo } from '@azure/msal-browser';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.sass']
})
export class NavigationBarComponent implements OnInit {

  constructor(
    private auth: AADAuthenticationService,
    private router: Router,
    private modalService: BsModalService,
    private alert: AlertService,
    private environment: EnvironmentService
  ) { }

  ngOnInit(): void {
  }

  isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }

  getLoggedUser(): AccountInfo {
    return this.auth.getLoggedUser();
  }

  getEnvironmentForTitle() {
    return this.auth.isLoggedIn() ? `(${this.environment.environment})` : ''
  }

  onSignOut() {
    this.modalService.show(ConfirmModalComponent, {
      initialState: {
        message: "Are you sure you want to logout?",
        callback: (result) => {
          if (result == 'yes') {
            this.auth.logout(() => this.router.navigate(['login']));
          }
        }
      }
    });
  }

  onUser() {
    let user = this.getLoggedUser();
    if (user) {
      this.alert.info(JSON.stringify(user));
    }
  }
}
